import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'react-bootstrap';
import ClockLoader from 'react-spinners/ClockLoader';
import {toast} from 'react-toastify';
import linkifyHtml from 'linkify-html';

export default function DirectChat(props) {
  //   const [messages, setMessages] = useState(0);
  const elementRef = useRef();
  const [isLoading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    setTimeout(function () {
      console.log(props.messages);
      if (elementRef.current) {
        elementRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        });
      }
    }, 1000);
  }, [props.messages]);

  useEffect(() => {
    console.log(props.panel);
  }, [props.panel]);

  const checkImageUrl = (url) => {
    return (
      url.match(/\.(jpeg|jpg|gif|png)$/) != null &&
      url.includes('api-passport.advanceagro.net/img/car')
    );
  };

  const handleSendMessage = async () => {
    setLoading(true);
    await props.onSendMessage(message);
    setMessage('');
    setLoading(false);
    // elementRef.current.scrollIntoView();
  };
  return (
    <div className="card card-primary card-outline direct-chat direct-chat-primary">
      <div className="card-header">
        <h3 className="card-title">กล่องข้อความ</h3>
      </div>
      <div className="card-body" style={{backgroundColor: '#8cabd8'}}>
        <div className="direct-chat-messages">
          {props.messages.map((e, i) => (
            <div
              className={e.isMe ? 'direct-chat-msg right' : 'direct-chat-msg'}
              key={`c-${i}`}
            >
              <div
                className={e.showInfo ? 'direct-chat-infos clearfix' : 'd-none'}
              >
                <span
                  className={
                    e.isMe
                      ? 'direct-chat-name float-right'
                      : 'direct-chat-name float-left'
                  }
                >
                  {e.displayName}
                </span>
                <span
                  className={
                    e.isMe
                      ? 'direct-chat-timestamp float-left'
                      : 'direct-chat-timestamp float-right'
                  }
                >
                  {e.createdDateTime}
                </span>
              </div>
              <img className="direct-chat-img" src={e.avatar} />
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    e.contentType === 'img-scan' ? (
                      `<div class="ocrloader"><em><img width="128px" height="128px" src="data:image/jpeg;base64,${e.content}"/></em><span></span></div>`
                    ) : (
                      linkifyHtml(e.content, {
                        defaultProtocol: 'https',
                        target: '_blank'
                      })
                    )
                  // checkImageUrl(e.content) ? (
                  //   <img
                  //     alt="aaaaa"
                  //     src={e.content}
                  //     style={{
                  //       margin: '0.3vh',
                  //       maxHeight: 150,
                  //       maxWidth: 150,
                  //       padding: '1vh'
                  //     }}
                  //   />
                  // ) : (
                  //   linkifyHtml(e.content, {defaultProtocol: 'https'})
                  // )
                }}
                className="direct-chat-text"
                style={{whiteSpace: 'pre-wrap'}}
              />
              {/* </div> */}
            </div>
          ))}
          <div ref={elementRef} />
        </div>
      </div>
      <div className="card-footer">
        <div className="input-group">
          <div className={isLoading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" size="20" />
          </div>
          <input
            value={message}
            type="text"
            name="message"
            onChange={(e) => {
              setMessage(e.target.value);
              // elementRef.current.scrollIntoView();
            }}
            onKeyUp={(e) => {
              if (e.code === 'Enter') {
                e.preventDefault();
                handleSendMessage();
                //   login(values.email, values.password);
              }
            }}
            placeholder="Type Message ..."
            className="form-control"
          />
          <span className="input-group-append">
            <button
              className="btn btn-primary"
              onClick={handleSendMessage}
              disabled={message.trim().length <= 0}
            >
              <i className="fas fa-paper-plane" />
            </button>
          </span>
          <span className={props.isPublic ? 'input-group-append' : 'd-none'}>
            <button
              className="btn btn-success"
              onClick={() => {
                if (props.isPublic) props.onOpenUpload(true);
                else toast.warning('เฉพาะการเดินทางสาธารณะหรือ CR เท่านั้น');
              }}
              // disabled={!props.isPublic}
            >
              <i className="fas fa-paperclip" />
            </button>
          </span>
          <span className={props.isPublic ? 'input-group-append' : 'd-none'}>
            <button
              className="btn btn-info"
              onClick={() => {
                if (props.isPublic) props.onOpenUploadGps(true);
                else toast.warning('เฉพาะการเดินทางสาธารณะหรือ CR เท่านั้น');
              }}
            >
              <i className="fas fa-image" />
            </button>
          </span>
        </div>
        <div
          className={
            props.panel.isMe
              ? 'input-group d-flex justify-content-between'
              : 'd-none'
          }
        >
          <Button
            onClick={props.onEdit}
            className="col-5 mt-2"
            variant="success"
            disabled={!props.panel.isEditable}
          >
            แก้ไข
          </Button>
          <Button
            onClick={props.onCancel}
            className="col-5 mt-2"
            variant="warning"
            disabled={!props.panel.isCancelable}
          >
            ยกเลิก
          </Button>
        </div>
        <div
          className={
            !props.panel.isMe
              ? 'input-group d-flex justify-content-between'
              : 'd-none'
          }
        >
          <Button
            onClick={props.onAgree}
            className="col-5 mt-2"
            variant="primary"
            disabled={!props.panel.isApprovable}
          >
            อนุมัติ
          </Button>
          <Button
            onClick={props.onReject}
            className="col-5 mt-2"
            variant="danger"
            disabled={!props.panel.isRejectable}
          >
            ไม่อนุมัติ
          </Button>
        </div>
      </div>
    </div>
  );
}
